import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../helper/service/auth.service';
import { DashboardService } from 'src/app/modules/service/dashboard.service';
import { AuthApiService } from 'src/app/core/service/auth-api.service';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss']
})
export class AuthLayoutComponent implements OnInit {
  profile: string = '';
  logo = this.auth.currentSettingValue?.logo_path;
  title = this.auth.currentSettingValue?.companyName;
  theme_color = '#a5bdfd';
  theme = `background-color: ${this.theme_color}`;

  constructor(
    private auth: AuthService,
    private authApi: AuthApiService,
    private router: Router,
    private dashServe: DashboardService
  ) { }

  ngOnInit(): void {
    if (this.router.url.includes('pw')) {
      this.theme_color = '#1c6485';
    }
    this.dashServe?.stopApiSub();
    this.image();
  }

  image() {
    this.authApi.getSetting().then((res: any) => {
      console.log('login res', res.result.theme_color);
      this.profile = res.result.logo_path;
      this.theme_color = res.result.theme_color || '#a5bdfd';
    });
  }
}
